import React from 'react'
import { Container } from '@kogk/common'
import { AspectRatioBox, VideoContentType } from '..'
import cn from 'classnames'

const Video: React.FC<{ video: VideoContentType; containerClass?: string }> = ({ video, containerClass }) => {
  const generateUrlFromService = (service: string, id: string, extraParams?: string) => {
    if (service === 'youtube') {
      return `https://www.youtube.com/embed/${id}`
    } else if (service === 'vimeo') {
      return `https://player.vimeo.com/video/${id}${extraParams ?? ''}`
    } else return ''
  }

  if (!video.service || !video.id) return null

  return (
    <Container className={cn('pt-2', containerClass)}>
      {video.title && <h4 className='video-modal__title'>{video.title}</h4>}
      <AspectRatioBox ratio='widescreen'>
        <iframe
          src={generateUrlFromService(video.service, video.id, video.extraParams)}
          allow='autoplay;'
          allowFullScreen
          className='video__iframe'
          title={video.title ?? 'Video'}
        ></iframe>
      </AspectRatioBox>
      <p className='caption'>{video.caption ? video.caption : ''}</p>
    </Container>
  )
}

export default Video
